import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import AircraftList from "@/pages/AircraftList";
import AircraftForm from "@/pages/AircraftForm";
import RouteList from "@/pages/RouteList";
import RouteForm from "@/pages/RouteForm";
import PilotList from "@/pages/PilotList";
import PilotForm from "@/pages/PilotForm";
import BriefingList from "@/pages/BriefingList";
import BriefingWorkspace from "@/pages/BriefingWorkspace";
import ResourcesPage from "@/pages/ResourcesPage";
import VacLibraryPage from "@/pages/VacLibraryPage";
import SharedBriefing from "@/pages/SharedBriefing";

const Page = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  useEffect(() => {
    document.title = "VFR Nav Organizer";
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/shared/:token" element={<SharedBriefing />} />
            <Route path="/" element={<Page><Dashboard /></Page>} />
            <Route path="/aircraft" element={<Page><AircraftList /></Page>} />
            <Route path="/aircraft/new" element={<Page><AircraftForm /></Page>} />
            <Route path="/aircraft/:id" element={<Page><AircraftForm /></Page>} />
            <Route path="/routes" element={<Page><RouteList /></Page>} />
            <Route path="/routes/new" element={<Page><RouteForm /></Page>} />
            <Route path="/routes/:id" element={<Page><RouteForm /></Page>} />
            <Route path="/pilots" element={<Page><PilotList /></Page>} />
            <Route path="/pilots/new" element={<Page><PilotForm /></Page>} />
            <Route path="/pilots/:id" element={<Page><PilotForm /></Page>} />
            <Route path="/resources" element={<Page><ResourcesPage /></Page>} />
            <Route path="/vac" element={<Page><VacLibraryPage /></Page>} />
            <Route path="/briefings" element={<Page><BriefingList /></Page>} />
            <Route path="/briefings/:id" element={<Page><BriefingWorkspace /></Page>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
